/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 2226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ handleFormInputs; },
/* harmony export */   "a": function() { return /* binding */ handleSelectedVariantAvailability; }
/* harmony export */ });
/* harmony import */ var _utils_product_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6955);
/* harmony import */ var _add_button_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6985);


/**
 * Handle form inputs.
 * Sets an change event listener on all the fieldset elements and checks if the values matches a product variant.
 *
 * @param value {string}
 */

var linkVariantSettings = function linkVariantSettings(variantString) {
  var value = variantString.split(' + ')[0].split('/')[0];
  var options = document.querySelectorAll('.product-variants option');
  var radios = document.querySelectorAll('.product-variants input[type="radio"]');
  options.forEach(function (option) {
    if (option.value.includes(value)) {
      option.checked = true;
    }
  });
  radios.forEach(function (radio) {
    if (radio.value.includes(value)) {
      radio.checked = true;
    }
  });
  areAllVariantElementsAValidVariant();
};
/**
 * Handle form inputs.
 * Sets an change event listener on all the fieldset elements and checks if the values matches a product variant.
 *
 * @param form {HTMLElement}
 */


var handleFormInputs = function handleFormInputs(form) {
  var parentVariantsElement = form.querySelector('.product-variants');

  if (parentVariantsElement) {
    // select all fieldset elements.
    var allFieldsetElements = parentVariantsElement.querySelectorAll('fieldset');
    allFieldsetElements.forEach(function (fieldsetElement) {
      fieldsetElement.addEventListener('change', function (e) {
        areAllVariantElementsAValidVariant();
        linkVariantSettings(e.target.value); // sessionStorage.setItem('selectedVariant', e.target.value)
      });
    });
  }
};
/**
 * Are all variant elements valid variants.
 * Check if all variant elements are valid variants if not throw error.
 */


var areAllVariantElementsAValidVariant = function areAllVariantElementsAValidVariant() {
  var parentVariantsElement = document.querySelector('.product-variants');
  var allVariantElements = parentVariantsElement.querySelectorAll('.variant');
  var correctVariant = (0,_utils_product_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCorrectVariantFromOptions */ .Cz)(allVariantElements);

  if (correctVariant === null) {
    _add_button_state__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setMakeSelection */ .Z.setMakeSelection();
  } else {
    handleFoundCorrectVariant(correctVariant);
  }
};
/**
 * Set max quantity to quantity selector.
 *
 * @param variantData {object}
 */


var handleMaxQuantity = function handleMaxQuantity(variantData) {
  var quantitySelector = document.querySelector('.js-quantity-input');
  var maxQuantity = variantData.inventory_quantity;

  if (quantitySelector) {
    quantitySelector.dataset.max = maxQuantity;
  }
};
/**
 * Handle found correct variant.
 *
 * @param variantData {object}
 */


var handleFoundCorrectVariant = function handleFoundCorrectVariant(variantData) {
  (0,_utils_product_utils__WEBPACK_IMPORTED_MODULE_0__/* .handleSetVariant */ .zw)(variantData);
  handleSelectedVariantAvailability(variantData);
  handleMaxQuantity(variantData);
  handleUrlVariant(variantData); // if(isProductSet) {
  // setSetProducts(variantData.metafields)
  // }
};

var handleUrlVariant = function handleUrlVariant(variantData) {
  var url = new URL(window.location.href);
  var variantId = variantData.id;
  url.searchParams.set('variant', variantId);
  window.history.replaceState({}, '', url);
};
/**
 * is the selected variant available
 */


var handleSelectedVariantAvailability = function handleSelectedVariantAvailability() {
  var variant = (0,_utils_product_utils__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedVariant */ .c)();
  var button = document.querySelector('#addToBagButton');

  if (variant === null) {
    // Set button to disabled.
    _add_button_state__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setMakeSelection */ .Z.setMakeSelection();
  } else {
    if ((0,_utils_product_utils__WEBPACK_IMPORTED_MODULE_0__/* .isVariantAvailable */ .K7)(variant)) {
      // Set button to active.
      _add_button_state__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setActive */ .Z.setActive();
    } else if (variant.tags.includes('eruit')) {
      // Set button to disabled.
      _add_button_state__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setPermanentSoldOut */ .Z.setPermanentSoldOut();
    } else if (button.classList.contains('preorder')) {// preorder so do nothing
    } else {
      // Set button to disabled.
      _add_button_state__WEBPACK_IMPORTED_MODULE_1__/* ["default"].setDisabled */ .Z.setDisabled();
    }
  }
}; // initial load klaviyo


(0,_utils_product_utils__WEBPACK_IMPORTED_MODULE_0__/* .handleSetVariant */ .zw)((0,_utils_product_utils__WEBPACK_IMPORTED_MODULE_0__/* .getSelectedVariant */ .c)()); // /**
//  * Handle quantity selector.
//  */
// const handleQuantity = () => {
//   const productQuantityElement = document.querySelector('.product-quantity')
//   // If there is no quantity selector don't set the event listener.
//   if (productQuantityElement) {
//     productQuantityElement.addEventListener('change', handleNewQuantityPrice)
//   }
// }
// /**
//  * Update price in submit button
//  */
// const handleNewQuantityPrice = () => {
//   // Get variant.
//   const variant = getSelectedVariant()
//   // Get value of quantity selector (if there is one)
//   const quantityElement = document.querySelector('.product-quantity')
//   let defaultQuantity = 1
//   if (quantityElement) {
//     const quantitySelectElement = quantityElement.querySelector('select')
//     const quantityValue = quantitySelectElement
//       ? quantitySelectElement.value
//       : null
//     if (quantityValue === null) {
//       // Do nothing.
//     } else {
//       defaultQuantity = quantityValue
//     }
//   }
//   if (variant) {
//     // Get price of variant.
//     const compareAtPrice = variant.compare_at_price
//       ? variant.compare_at_price
//       : null
//     const price = variant.price ? variant.price : null
//     // Multiply the compare at price and the price.
//     const finalCompareAtPrice = compareAtPrice
//       ? compareAtPrice * defaultQuantity
//       : null
//     const finalPrice = price ? price * defaultQuantity : null
//     // Set variant availability.
//     handleSelectedVariantAvailability()
//     // Get compare at price of variant.
//     addButton.updatePrice(finalPrice, finalCompareAtPrice)
//   }
// }



/***/ }),

/***/ 8638:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5861);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5671);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2963);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1120);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7112);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7757);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_product__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2226);
/* harmony import */ var _utils_product_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6955);
/* harmony import */ var _components_add_button_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6985);
/* harmony import */ var _services_shopify_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6835);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var ProductForm = /*#__PURE__*/function (_HTMLElement) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(ProductForm, _HTMLElement);

  var _super = _createSuper(ProductForm);

  function ProductForm() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, ProductForm);

    _this = _super.call(this); // This refers to the ProductForm element.

    var form = _this.querySelector('form');

    var addToCartButton = _this.querySelector('#addToBagButton');
    /**
     * Attach listener to the form submit buttons.
     *
     * @param event {object}
     *
     * @returns {boolean}
     */


    var handleAddToCart = /*#__PURE__*/function () {
      var _ref = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
        var formData, setProductData;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = Object.fromEntries(new FormData(event.target).entries());
                setProductData = _this.querySelectorAll('.set-product-data'); // Check if variant id is set and the form is valid (all required fields are entered).

                if (!(formData.productVariant && form.checkValidity() && setProductData.length >= 1)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return _services_shopify_cart__WEBPACK_IMPORTED_MODULE_6__/* ["default"].addSetProduct */ .Z.addSetProduct(formData, addToCartButton, setProductData);

              case 5:
                _context.next = 13;
                break;

              case 7:
                if (!(formData.productVariant && form.checkValidity())) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return _services_shopify_cart__WEBPACK_IMPORTED_MODULE_6__/* ["default"].add */ .Z.add(formData, addToCartButton);

              case 10:
                _context.next = 13;
                break;

              case 12:
                _components_add_button_state__WEBPACK_IMPORTED_MODULE_5__/* ["default"].setMakeSelection */ .Z.setMakeSelection();

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleAddToCart(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    if (form) {
      // Check if selected variant is sold out.
      if (!addToCartButton.classList.contains('preorder')) {
        (0,_components_product__WEBPACK_IMPORTED_MODULE_3__/* .handleSelectedVariantAvailability */ .a)();
      } // Handle form inputs.


      (0,_components_product__WEBPACK_IMPORTED_MODULE_3__/* .handleFormInputs */ .W)(form); // Handle quantity
      // handleQuantity()

      form.addEventListener('submit', function (event) {
        // Prevent going to the add to cart page.
        event.preventDefault();
        handleAddToCart(event);
      });
    }

    return _this;
  }

  return ProductForm;
}( /*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(HTMLElement)); // Check if element is defined, if not define it..


if (customElements.get('product-form') === undefined) {
  customElements.define('product-form', ProductForm);
}

/***/ }),

/***/ 6955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getSelectedVariant; },
/* harmony export */   "Cz": function() { return /* binding */ getCorrectVariantFromOptions; },
/* harmony export */   "K7": function() { return /* binding */ isVariantAvailable; },
/* harmony export */   "zw": function() { return /* binding */ handleSetVariant; }
/* harmony export */ });
/* unused harmony exports getAllVariants, getVariantFromId, getValueFromVariantSelector, setSetProducts */
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5861);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7757);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7750);
/* harmony import */ var _type_check__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(218);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);






/**
 * Get all variants data.
 *
 * @returns {Object|null}
 */

var getAllVariants = function getAllVariants() {
  var variantsDataElement = document.getElementById('variants-data');
  var allVariants = variantsDataElement ? JSON.parse(variantsDataElement.innerHTML).variants : null;
  return (0,_type_check__WEBPACK_IMPORTED_MODULE_2__/* .returnObjectOrNull */ .H0)(allVariants);
};
/**
 * Get variant from id.
 *
 * @param variantId {number}
 *
 * @returns {Object|null}
 */


var getVariantFromId = function getVariantFromId(variantId) {
  var allVariants = getAllVariants();
  var correctVariant = allVariants.find(function (element) {
    return element.id == variantId;
  });
  return (0,_type_check__WEBPACK_IMPORTED_MODULE_2__/* .returnObjectOrNull */ .H0)(correctVariant);
};
/**
 * Get selected variants.
 *
 * @returns {number|null}
 */


var getSelectedVariant = function getSelectedVariant() {
  var variantIdElement = document.querySelector('#variantId');
  var variantId = variantIdElement ? Number(variantIdElement.value) : null;
  var variant = getVariantFromId(variantId);
  return (0,_type_check__WEBPACK_IMPORTED_MODULE_2__/* .returnObjectOrNull */ .H0)(variant);
};
/**
 * Get value from variant Selector.
 * Returns the selected value from a selector element.
 *
 * @param variantElement {HTMLElement}
 * @param optionName {string}
 *
 * @returns {*}
 */


var getValueFromVariantSelector = function getValueFromVariantSelector(variantElement, optionName) {
  var checkedElement = variantElement.querySelector('select') !== null ? variantElement.querySelector('select') : variantElement.querySelector('input[type="radio"]:checked');
  return (0,_type_check__WEBPACK_IMPORTED_MODULE_2__/* .returnStringOrNull */ .h_)(checkedElement.value);
};
/**
 * Get correct variant from selected options.
 *
 * @param variantOptions {object}
 *
 * @returns {object|null}
 */


var getCorrectVariantFromOptions = function getCorrectVariantFromOptions(variantOptions) {
  var allVariants = getAllVariants();

  if (allVariants != null) {
    // Determine the correct one to get the id
    var selectedOptions = '';
    variantOptions.forEach(function (variantElement) {
      var optionName = variantElement.dataset.optionName; // Join all the selected options into one string.

      selectedOptions = selectedOptions + ' - ' + getValueFromVariantSelector(variantElement, optionName);
    }); // Splice the string into an array.

    selectedOptions = selectedOptions.slice(3);
    return (0,_type_check__WEBPACK_IMPORTED_MODULE_2__/* .returnObjectOrNull */ .H0)(allVariants.find(function (element) {
      return element.options.includes(selectedOptions);
    }));
  }

  return null;
};
/**
 * Is variant available.
 *
 * @param variant {object}
 *
 * @returns {boolean}
 */


var isVariantAvailable = function isVariantAvailable(variant) {
  return (0,_type_check__WEBPACK_IMPORTED_MODULE_2__/* .returnBooleanOrNull */ .k9)(variant.available === true);
};
/**
 * Handles inventory visibility
 */


var handleInventory = function handleInventory(variant) {
  var inventory = variant.inventory_quantity;
  var inventoryParent = document.querySelector('.product-inventory');
  var inventoryBase = "<p class=\"product-inventory__text\">".concat(window.product.only, " <span class=\"js-inventory-ammount\"> </span><span class=\"js-multiplier\"></span> ").concat(window.product.available, "</p>");

  if (inventory <= 10 && inventory > 0) {
    inventoryParent.innerHTML = inventoryBase;
    var inventoryElement = document.querySelector('.js-inventory-ammount');
    var multiplier = document.querySelector('.js-multiplier');
    inventoryElement.innerHTML = inventory;
    inventoryParent.classList.remove('product-inventory--hidden');
    inventory === 1 ? multiplier.innerHTML = window.product.piece : multiplier.innerHTML = window.product.pieces;
  } else if (inventory > 10) {
    var text = document.querySelector('.product-inventory__text');
    text.innerHTML = window.product.in_stock;
    inventoryParent.classList.remove('product-inventory--hidden');
  } else {
    inventoryParent.classList.add('product-inventory--hidden');
  }
};

const activeSubscriptions = new Set();

const sendSubscribeRequest = async (email, id) => {
  const key = `${email}::${id}`;

  if (activeSubscriptions.has(key)) {
    console.log('Duplicate submission blocked for', key);
    return;
  }

  activeSubscriptions.add(key);

  console.log('START sendSubscribeRequest', { email, id });

  const payload = {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: { email },
          },
        },
        channels: ['EMAIL'],
      },
      relationships: {
        variant: {
          data: {
            type: 'catalog-variant',
            id: `$shopify:::$default:::${id}`,
          },
        },
      },
    },
  };

  try {
    const response = await fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=UzHRN9',
      {
        method: 'POST',
        headers: {
          revision: '2026-01-15',
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(payload),
      }
    );

    console.log('after fetch', response.status);

    let data = null;
    try {
      data = await response.json();
    } catch (e) {
      console.log('no JSON body');
    }

    console.log('response data:', data);

    if (!response.ok) {
      console.error('Request failed', response.status, data);
      return;
    }

    const klaviyoTitle = document.querySelector('.klaviyo-bis__title h2');
    const emailInput = document.querySelector('#klaviyo-bis-email');

    console.log('elements:', { klaviyoTitle, emailInput });

    if (klaviyoTitle && emailInput) {
      const currentTitle = klaviyoTitle.innerHTML;
      const confirmText =
        klaviyoTitle.dataset.confirm || 'Thanks! You are subscribed.';

      klaviyoTitle.innerHTML = confirmText;
      emailInput.value = '';

      setTimeout(() => {
        klaviyoTitle.innerHTML = currentTitle;
      }, 5000);
    }

    console.log('END sendSubscribeRequest');
  } catch (error) {
    console.error('FETCH ERROR:', error);
  } finally {
    activeSubscriptions.delete(key);
  }
};
/**
 * Handles inventory visibility
 */


var handleProductPricing = function handleProductPricing(variant) {
  var priceElement = document.querySelector('.js-price');
  var freeShippingElement = document.querySelector('.js-shipping');
  var klaviyoBis = document.querySelector('.klaviyo-bis');
  var floatingElement = document.querySelector('.js-float-price');
  var freeShippingAmount = parseInt(freeShippingElement.getAttribute('data-free-shipping-amount'));

  if (variant.compare_at_price === null) {
    priceElement.innerHTML = (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__/* .formatMoney */ .l)(variant.price, window.product.money_format);
    floatingElement.innerHTML = (0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__/* .formatMoney */ .l)(variant.price, window.product.money_format);
    variant.price >= freeShippingAmount ? freeShippingElement.classList.remove('shipping--hidden') : freeShippingElement.classList.add('shipping--hidden');
  } else {
    priceElement.innerHTML = "<span class=\"compare\">".concat((0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__/* .formatMoney */ .l)(variant.price, window.product.money_format), "</span> <s>").concat((0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__/* .formatMoney */ .l)(variant.compare_at_price, window.product.money_format), "</s>");
    floatingElement.innerHTML = "<span class=\"compare\">".concat((0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__/* .formatMoney */ .l)(variant.price, window.product.money_format), "</span> <s>").concat((0,_shopify_theme_currency__WEBPACK_IMPORTED_MODULE_4__/* .formatMoney */ .l)(variant.compare_at_price, window.product.money_format), "</s>");
    variant.price >= freeShippingAmount ? freeShippingElement.classList.remove('shipping--hidden') : freeShippingElement.classList.add('shipping--hidden');
  }

  if (variant.available == false && klaviyoBis !== undefined && !variant.tags.includes('eruit')) {
    klaviyoBis.classList.remove('klaviyo-bis--hidden');
    var notifyButton = document.querySelector('#klaviyo-submit');
    notifyButton.setAttribute("data-varId", variant.id );
    var emailButton = document.querySelector('#klaviyo-bis-email');
    var formData = new FormData();
    notifyButton.addEventListener('click', function () {
      formData.append('a', 'UzHRN9');
      formData.append('email', emailButton.value);
      formData.append('variant', variant.id);
      console.log("var:", variant.id);
      formData.append('product', notifyButton.dataset.productId);
      formData.append('platform', 'shopify');
      console.log("Formdata:",formData );
      // sendSubscribeRequest(emailButton.value, variant.id);
    });
  } else {
    klaviyoBis.classList.add('klaviyo-bis--hidden');
  }
};
var notifyButton = document.querySelector('#klaviyo-submit');
var emailButton = document.querySelector('#klaviyo-bis-email');
notifyButton.addEventListener('click', function () {
  sendSubscribeRequest(emailButton.value, notifyButton.getAttribute("data-varId"));
});
/**
 * Handle set variant in HTML.
 *
 * @param variant {object}
 */


var handleSetVariant = function handleSetVariant(variant) {
  var variantId = variant.id;
  setVariantId(variantId);
  handleInventory(variant);
  handleProductPricing(variant);
};
/**
 * Set variant ID in the product form.
 *
 * @param variantId {number}
 */


var setVariantId = function setVariantId(variantId) {
  var variantIdElement = document.querySelector('#variantId');
  variantIdElement.value = variantId;
  if (document.querySelector('[name="id"]') != null) document.querySelector('[name="id"]').value = variantId;
};
/**
 * Set variant ID in the product form.
 *
 * @param variantId {number}
 */


var setSetProducts = function setSetProducts(products) {
  var setElement = document.querySelectorAll('.set-products .product');

  if (setElement && products) {
    setElement.forEach(function (element, i) {
      var imageElement = element.querySelector('.image-holder img');
      var titleElement = element.querySelector('.text-holder__title');
      var subtitleElement = element.querySelector('.text-holder__subtitle');
      var optionElement = element.querySelector('.text-holder__option');
      var productData = JSON.parse(document.querySelector(".".concat(products[i].sku)).innerHTML);

      if (i <= products.length && productData) {
        var title = products[i].name.split(' - ')[0].replace(products[i].option1, '');
        element.classList.add('fade');
        imageElement.src = productData.product_image_url;
        titleElement.innerHTML = title;
        subtitleElement.innerHTML = products[i].option1;
        optionElement.innerHTML = products[i].option2;
        setTimeout(function () {
          element.classList.remove('fade');
        }, 1000);
      }
    });
  }
};



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 6641;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			6641: 0,
/******/ 			44: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(8638); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;